import type { Moment } from 'moment';
import moment from 'utils/moment';

/**
 * Ngay calendar dang hien thi, dinh dang tham so API `YYYY-MM-DD`.
 *
 * Moi cho tai lai calendar phai di qua day. Handler socket truoc day tu format
 * `moment()` nen luon tai ngay hom nay; response cua hom nay thay nguyen
 * `calendar.data` va xoa lich cua ngay user dang xem — lich vua dat hien len
 * roi bien mat sau khoang 170ms.
 *
 * Khong co ngay dang xem thi giu nguyen hanh vi cu la hom nay, khong tra chuoi
 * rong: chuoi rong khien API tra ve du lieu khong xac dinh.
 */
export const toCalendarDateParam = (date?: Moment | null): string =>
  (date && date.isValid() ? date : moment()).format('YYYY-MM-DD');

/**
 * Response cua mot request calendar co con dung ngay dang hien thi khong.
 *
 * Ngay dang xem co the doi trong luc request bay: dat lich cho ngay khac, hoac
 * nguoi dung bam sang ngay khac. Response ve muon van mang du lieu cua ngay cu,
 * va vi `calendar.getData.success` thay NGUYEN `calendar.data` nen no se xoa
 * sach lich cua ngay dang xem — ke ca lich vua dat xong.
 *
 * Khong co ngay yeu cau thi khong chan: request kieu do da hong san o cho khac,
 * chan them chi lam mat du lieu ma khong sua duoc gi.
 */
export const isStaleCalendarDate = (
  requestedDate?: string | null,
  viewing?: Moment | null,
): boolean => !!requestedDate && requestedDate !== toCalendarDateParam(viewing);
